export const dataTableSettings = {
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
};
